<template>
  <div class="authority-manage position-header">
    <navHeader :titleList="['线上活动']" />
    <div class="rhBrand-content common-padding">
      <el-card class="box-card flex-1 table-card">
        <el-row class="common-margin flex-1 table-main">
          <el-table
              :data="tableData"
              class="flex-1" stripe height="100%"
              style="width: 100%"
              border
          >
            <el-table-column type="index" width="80px" align="center" label="序号" fixed> </el-table-column>
            <el-table-column prop="activityType" align="center" label="类型" width="200px">
              <template slot-scope="scope">
                {{getType(scope.row.activityType)}}
              </template>
            </el-table-column>
            <el-table-column prop="publicityMap" align="center" label="宣传图" width="260px">
              <template slot-scope="scope">
                <el-image
                    style="width: auto; height: 60px;"
                    :src="scope.row.publicityMap"
                    :preview-src-list="[scope.row.publicityMap]"
                    fit="contain"></el-image>
              </template>
            </el-table-column>
            <el-table-column prop="title" align="center" label="标题" width="280px" show-overflow-tooltip></el-table-column>
            <el-table-column prop="ruleDescription" align="center" width="700px" label="规则说明" show-overflow-tooltip>
              <template slot-scope="scope">
                <div class="rule-box" v-html="scope.row.ruleDescription"></div>
              </template>
            </el-table-column>
            <el-table-column prop="time" align="center" label="活动时间" width="300px" show-overflow-tooltip>
              <template slot-scope="scope">
                <div>{{getTime(scope.row.startTime, scope.row.endTime)}}</div>
              </template>
            </el-table-column>
            <el-table-column align="center" label="报名时间" width="300px" show-overflow-tooltip>
              <template slot-scope="scope">
                <div>{{getTime(scope.row.registrationStartTime, scope.row.registrationEndTime)}}</div>
              </template>
            </el-table-column>
            <el-table-column align="center" label="操作" width="120" fixed="right">
              <template slot-scope="scope">
                <div class="btn-box">
                  <el-button
                      icon="el-icon-bell"
                      type="text"
                      size="mini"
                      @click="getList(scope.row.id,scope.row.registrationStartTime, scope.row.registrationEndTime, scope.row.activityType)"
                  >活动报名</el-button
                  >
                </div>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
              @current-change="handleCurrentChange"
              @size-change="handleSizeChange"
              :current-page.sync="currentPage"
              :page-size="pageSize"
              layout="total, prev, pager, next, sizes"
              :total="total"
          >
          </el-pagination>
        </el-row>
      </el-card>
    </div>
    <el-dialog class="exhibition-dialog" width="70%" :close-on-click-modal="false" :visible.sync="outerVisible">
      <bannerAndAdvertIndex ref="bannerAndAdvertIndex" @isShowActivity="isShowActivity" :isShowEnroll="isShowEnroll" />
      <el-dialog
          class="exhibition-dialog"
          width="70%"
          :close-on-click-modal="false"
          :visible.sync="innerVisible"
          append-to-body>
        <activityList v-if="innerVisible" ref="activityList" :activityId="activityId" @updateList="updateList" :listType="listType" />
      </el-dialog>
    </el-dialog>
  </div>
</template>

<script>
import navHeader from '../../components/navHeader'
import bannerAndAdvertIndex from './bannerAndAdvertIndex'
import activityList from './activityList'

export default {
  name: 'index',
  data () {
    return {
      id: '',
      activityId: '',
      isShowEnroll: false,
      type: '',
      title: '',
      status: '',
      innerId: '',
      innerType: 'add',
      tableData: [],
      tableHeight: 0,
      typeList: [
        {
          label: '产品',
          value: '1'
        },
        {
          label: '品牌',
          value: '2'
        },
        {
          label: '展商',
          value: '3'
        }
      ],
      listType: '',
      companyVisible: false,
      outerVisible: false,
      innerVisible: false,
      currentPage: 1,
      pageSize: 10,
      total: 0
    }
  },
  components: {
    navHeader,
    bannerAndAdvertIndex,
    activityList
  },
  created () {
    this.tableHeight = document.documentElement.clientHeight - 360
    this.getPageList()
  },
  methods: {
    async getPageList () {
      let { data: res } = await this.$http.post('/boutiqueActivities/boutiqueActivities/signUpBoutiqueActivitiesList', {
        currentPage: this.currentPage,
        pageSize: this.pageSize
      })
      if (res.code === '200') {
        this.tableData = res.data.records
        this.total = parseInt(res.data.total)
      } else {
        this.$message.error(res.msg)
      }
    },
    reset () {
      this.title = ''
      this.type = ''
      this.status = ''
      this.getPageList()
    },
    async getList (id, startTime, endTime, type) {
      if (type === '3') {
        this.$confirm('是否报名?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          closeOnClickModal: false,
          showClose: false
        }).then(() => {
          this.$http.post('/boutiqueActivities/boutiqueActivities/addActivityRegistrationCompany', {activityId: id}).then(res => {
            if (res.data.code === '200') {
              this.$message.success(res.data.msg)
              this.getPageList()
            } else {
              this.$message.error(res.data.msg)
            }
          })
        })
      } else {
        let now = new Date()
        let start = new Date(startTime)
        let end = new Date(endTime)
        if (now < start || now > end) return this.$message.warning('活动报名已截止!')
        this.outerVisible = true
        this.activityId = id
        this.listType = type
        this.isShowEnroll = (now > start) && (now < end)
        this.$nextTick(() => {
          this.$refs.bannerAndAdvertIndex.getPageList(id)
        })
      }
    },
    updateList () {
      this.$refs.bannerAndAdvertIndex.getPageList(this.activityId)
    },
    // 分页
    handleCurrentChange (page) {
      this.currentPage = page
      this.getPageList()
    },
    handleSizeChange (size) {
      this.pageSize = size
      this.getPageList()
    },
    async isShowActivity () {
      this.innerVisible = true
    },
    getType (type) {
      let name = ''
      if (type === '1') {
        name = '产品'
      } else if (type === '2') {
        name = '品牌'
      } else if (type === '3') {
        name = '展商'
      }
      return name
    },
    getTime (time1, time2) {
      if (time1 && time2) {
        return time1 + '~' + time2
      } else {
        return ''
      }
    }
  }
}
</script>

<style lang="less">
.exhibition-dialog {
  .el-dialog {
    margin-top: 10vh!important;
  }
  .el-dialog__body {
    padding: 10px;
  }
}
.rule-box {
  width: 600px;
  margin: 0 auto;
  p {
    width: 600px;
    word-break: break-all;
    word-wrap: break-word;
    overflow: hidden;
  }
  word-break: break-all;
  word-wrap: break-word;
}
</style>



// WEBPACK FOOTER //
// src/pages/exhibitionActivity/index.vue